"use client";
import { cn } from "@/lib/utils";
import { useReducedMotion } from "framer-motion";
import React from "react";

interface BorderBeamProps {
  className?: string;
  duration?: number;
  delay?: number;
  colorFrom?: string;
  colorTo?: string;
  borderWidth?: number;
}

export const BorderBeam = ({
  className,
  duration = 12,
  delay = 0,
  colorFrom,
  colorTo = "transparent",
  borderWidth = 1.5,
}: BorderBeamProps) => {
  const prefersReduced = useReducedMotion();
  if (prefersReduced) return null;

  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-0 overflow-hidden rounded-[inherit]",
        className
      )}
      aria-hidden="true"
    >
      <div
        className="absolute animate-spin"
        style={{
          inset: "-1px",
          borderRadius: "inherit",
          padding: `${borderWidth}px`,
          animationDuration: `${duration}s`,
          animationTimingFunction: "linear",
          animationDelay: `${delay}s`,
          background: `conic-gradient(from 0deg, transparent 0deg, ${
            colorFrom ?? "hsl(var(--primary))"
          } 80deg, ${colorTo} 180deg, transparent 360deg)`,
          WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
          WebkitMaskComposite: "xor",
          maskComposite: "exclude",
        }}
      />
    </div>
  );
};
